export interface TradeOverlayTheme {
  buyColor: string;
  sellColor: string;
  tpColor: string;
  slColor: string;
  pendingColor: string;
  pnlPositiveColor: string;
  pnlNegativeColor: string;
  pnlNeutralColor: string;
  labelTextColor: string;
  dimmedOpacity: number;
}

export const defaultTradeOverlayTheme: TradeOverlayTheme = {
  buyColor: "#2196F3",
  sellColor: "#FF5722",
  tpColor: "#4CAF50",
  slColor: "#F44336",
  pendingColor: "#607D8B",
  pnlPositiveColor: "#4CAF50",
  pnlNegativeColor: "#F44336",
  pnlNeutralColor: "#9E9E9E",
  labelTextColor: "#FFFFFF",
  dimmedOpacity: 0.3,
};

export function withOpacity(color: string, opacity: number): string {
  if (!color.startsWith("#")) {
    return color;
  }

  const hex = color.slice(1);
  const fullHex =
    hex.length === 3
      ? hex
          .split("")
          .map((part) => part + part)
          .join("")
      : hex;

  if (fullHex.length !== 6) {
    return color;
  }

  const value = Number.parseInt(fullHex, 16);
  const red = (value >> 16) & 255;
  const green = (value >> 8) & 255;
  const blue = value & 255;

  return `rgba(${red}, ${green}, ${blue}, ${opacity})`;
}
